var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10867_31786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1573 4.85971C14.1573 2.46383 11.9938 0.514648 9.33448 0.514648C6.67518 0.514648 4.51168 2.46383 4.51168 4.85971C4.51168 6.5635 5.56194 8.10518 7.20911 8.82803C3.59202 9.68023 1 12.5661 1 16.0839V17.1459C1 17.3334 1.16884 17.4853 1.37713 17.4853H17.2918C17.5001 17.4853 17.669 17.3334 17.669 17.1459V16.0839C17.669 12.5946 15.0797 9.68217 11.4624 8.82868C13.1107 8.10586 14.1573 6.56343 14.1573 4.85971ZM5.26593 4.85971C5.26593 2.83814 7.09107 1.19347 9.33448 1.19347C11.5779 1.19347 13.403 2.83814 13.403 4.85971C13.403 6.91269 11.5779 8.58294 9.33448 8.58294C7.09107 8.58291 5.26593 6.91269 5.26593 4.85971ZM16.9147 16.8065H1.75425V16.0839C1.75425 12.3222 5.15472 9.26173 9.33448 9.26173C13.5142 9.26173 16.9147 12.3222 16.9147 16.0839V16.8065Z",
    fill: "#444444",
    stroke: "#444444",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10867_31786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.4735420506dcd57bd7b837284be6661d.svg";
export { ForwardRef as ReactComponent };